/**
 * Announcement Bar Rotation
 * - Rotates through announcement items on each page visit using localStorage
 * - Auto-rotates on a timer with fade-up animations
 */

(function() {
  const STORAGE_KEY = 'skall_announcement_index';
  const ROTATION_INTERVAL = 5000; // 5 seconds between rotations
  const snackbar = document.querySelector('[data-snackbar]');

  if (!snackbar) return;

  const items = snackbar.querySelectorAll('[data-snackbar-item]');
  const itemCount = parseInt(snackbar.dataset.itemCount, 10);

  // If only one item, no rotation needed
  if (itemCount <= 1) {
    if (items[0]) {
      items[0].classList.add('is-active');
    }
    snackbar.classList.add('is-initialized');
    return;
  }

  // Get last shown index from localStorage
  let lastIndex = parseInt(localStorage.getItem(STORAGE_KEY), 10);

  // If invalid or doesn't exist, start at -1 so next will be 0
  if (isNaN(lastIndex) || lastIndex < 0 || lastIndex >= itemCount) {
    lastIndex = -1;
  }

  // Calculate initial index (rotate from last visit)
  let currentIndex = (lastIndex + 1) % itemCount;

  // Store the new index
  localStorage.setItem(STORAGE_KEY, currentIndex);

  // Show initial item
  items[currentIndex].classList.add('is-active');

  // Mark as initialized so CSS knows JS has taken over
  snackbar.classList.add('is-initialized');

  // Auto-rotation with fade animation
  function rotateToNext() {
    const oldIndex = currentIndex;
    currentIndex = (currentIndex + 1) % itemCount;

    // Update localStorage
    localStorage.setItem(STORAGE_KEY, currentIndex);

    // Animate out old item (fade up and out)
    items[oldIndex].classList.add('is-exiting');
    items[oldIndex].classList.remove('is-active');

    // Animate in new item (fade up from bottom)
    items[currentIndex].classList.add('is-entering');

    // After animation completes, clean up classes
    setTimeout(() => {
      items[oldIndex].classList.remove('is-exiting');
      items[currentIndex].classList.remove('is-entering');
      items[currentIndex].classList.add('is-active');
    }, 400); // Match CSS transition duration
  }

  // Start auto-rotation
  setInterval(rotateToNext, ROTATION_INTERVAL);
})();
